export default __webpack_public_path__ + "static/media/VisaCard.5145986a.svg";